var render = function (_h,_vm) {var _c=_vm._c;return _c('i',{staticClass:"tm-beat-anchor",style:(_vm.props.styleObj)},[_c('i',{staticClass:"wticon wticon-note-small",class:{ '-down-beat': _vm.props.isDownBeat, '-is-used': _vm.props.isUsed }})])}
var staticRenderFns = []

export { render, staticRenderFns }